import { FunctionComponent } from "react"
import { IconType } from "react-icons"
import styled from "styled-components"

interface IIcon {
	component: IconType
	id?: string
	color?: string
	hoverColor?: string
	onClick?: () => void
}
const Icon: FunctionComponent<IIcon> = ({ component: Component, id, color, hoverColor, onClick }) => {
	return (
		<StyledIcon id={id} color={color} hoverColor={hoverColor} onClick={onClick}>
			<Component />
		</StyledIcon>
	)
}

export default Icon

interface IStyledIcon {
	hoverColor?: string
}

const StyledIcon = styled.div<IStyledIcon>`
	color: ${(props) => props.color};
	padding: 0px 16px;
	:hover {
		transition: background-color 0s, ease 0s;
		color: ${(props) => props.hoverColor};
	}
`
